import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import TimetoastPropTypes from '../../../constants/timetoast_prop_types'
import FormattedTime from '@components/FormattedTime'
import Image from '@components/Image'
import { getReadableTextColor } from '@helpers/color_scheme_helpers.js'
import { getPixelDataURL } from '../../../utils/canvas'
import { ThemeContext } from '../../../base/ThemeContext'
import { sanitize, markupAndSanitize } from '../../../utils/sanitize'

export default class Marker extends PureComponent {
  getImageContent() {
    const { data, photoData, lazyLoadImage } = this.props
    if (photoData) {
      const imageProcessingComplete =
        get(photoData, ['image_processing_complete']) === true ||
        get(photoData, ['attributes', 'image_processing_complete']) === true
      if (imageProcessingComplete) {
        const image = get(photoData, ['image_urls', 'medium']) || get(photoData, ['attributes', 'image_urls', 'medium'])
        if (image) {
          const { src, width, height } = image
          const imgStyle = {
            width: '100%',
            height: 'auto',
            display: 'block',
          }
          const loading = lazyLoadImage ? 'lazy' : null
          return (
            <div className="timeline-item__image">
              <Image src={src} width={width} height={height} alt={data.title} style={imgStyle} loading={loading} />
            </div>
          )
        }
      }
    }
    return null
  }

  getDescriptionContent() {
    const { data } = this.props
    const colorScheme = this.context
    const description = data.description
    const backgroundColor = colorScheme.secondary
    const color = getReadableTextColor(backgroundColor, colorScheme)
    const style = { backgroundColor, color }
    if (description !== '') {
      return (
        <div
          className="timeline-item__body"
          style={style}
          dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
        ></div>
      )
    }
    return null
  }

  render() {
    const { data } = this.props
    const colorScheme = this.context

    const image = this.getImageContent()
    const description = this.getDescriptionContent()

    const backgroundColor = colorScheme.highlight
    const color = getReadableTextColor(backgroundColor, colorScheme)
    const headerStyle = { backgroundColor }
    const titleStyle = { color }

    const itemStyle = { backgroundImage: `url(${getPixelDataURL(colorScheme.tertiary)})` } // main timeline line in vertical mode (narrow screens)
    const lineStyle = { backgroundColor: colorScheme.tertiary } // connector line to main timeline line in side by side mode (wide screens)
    const dotStyle = { backgroundColor: colorScheme.highlight }

    return (
      <li className="list-timeline__item timeline-item timeline-item--viewer" style={itemStyle}>
        <div className="timeline-item__line" style={lineStyle}></div>
        <div className="timeline-item__dot">
          <div className="dot__graphic" style={dotStyle}></div>
        </div>
        <div className="timeline-item__content-wrapper">
          <div className="timeline-item__content">
            <div className="timeline-item__header" style={headerStyle}>
              <div className="timeline-item__date">
                <FormattedTime dateTime={data.date} color={color} />
              </div>
              <h1 className="timeline-item__title" style={titleStyle}>
                {sanitize(data.title)}
              </h1>
            </div>
            {image}
            {description}
          </div>
        </div>
      </li>
    )
  }
}
Marker.contextType = ThemeContext

Marker.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  photoData: PropTypes.shape({
    image_processing_complete: PropTypes.bool.isRequired,
    image_urls: PropTypes.shape({
      medium: TimetoastPropTypes.image.isRequired,
    }),
  }),
  lazyLoadImage: PropTypes.bool,
}
Marker.defaultProps = {
  lazyLoadImage: true,
}
